import { useEffect, useState } from 'react'
import { MixpanelClient } from '~/plugins/mixpanel/client'

export const useInstallation = () => {
  const [promptInstall, setPromptInstall] = useState<any>(null)
  const [isVisible, setVisible] = useState(false)
  const [isInstalled, setInstalled] = useState(false)

  const mixpanel = MixpanelClient.use()

  useEffect(() => {
    const handleBeforeInstallPrompt = (event: any) => {
      event.preventDefault()
      setPromptInstall(event)
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt,
      )
    }
  }, [])

  useEffect(() => {
    const handleAppInstalled = () => {
      setInstalled(true)
      setVisible(false)
    }

    window.addEventListener('appinstalled', handleAppInstalled)

    return () => {
      window.removeEventListener('appinstalled', handleAppInstalled)
    }
  }, [])

  const install = () => {
    if (promptInstall) {
      promptInstall.prompt()
      promptInstall.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          // Accepted
          mixpanel.track('pwa.prompt.accepted')
        } else {
          // Refused
          mixpanel.track('pwa.prompt.refused')
        }
        setPromptInstall(null)
        setVisible(false)
      })
    }
  }

  return {
    isVisible,
    isInstalled,
    setVisible,
    canInstallPrompt: !!promptInstall,
    install,
  }
}
